<template>
  <div class="WorkReport">
    <WorkReportTop></WorkReportTop>
    <WorkReportBottom></WorkReportBottom>
  </div>
</template>

<script>
import WorkReportTop from './components/WorkReportTop.vue'
import WorkReportBottom from './components/WorkReportBottom.vue'
import Commonbtn from '../../../../../components/common-btn.vue'
export default {
  components: { WorkReportTop, WorkReportBottom , Commonbtn },
  props: {},
  data() {
    return {

    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {
    SubmitReport(){
      
    }
  },
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
.WorkReport {
  width: 950px;
    // border: 1px solid red;
  margin-left: 0px;

 
}
</style>